import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MeditaionRoutingModule } from './meditation-routing.module';
import { MeditationComponent } from './meditation.component';
import { SharedModule } from '../../shared/shared.module';
import { HomeService } from '../../services/home.service';
import { FormsModule } from '@angular/forms';
import { PerfectScrollbarModule, PerfectScrollbarConfigInterface } from 'ngx-perfect-scrollbar';

@NgModule({
  imports: [
    CommonModule,
    MeditaionRoutingModule,
    SharedModule,
    FormsModule,
    PerfectScrollbarModule
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  declarations: [MeditationComponent],
  providers:[HomeService]
})
export class MeditationModule { }




// WEBPACK FOOTER //
// /Volumes/Projects/WellBrain_Azure_Web/src/app/components/meditation/meditation.module.ts